import Accordion from '@base/components/src/Accordion';
import useBullseyeBucks from '@package/hooks/src/useBullseyeBucks';
import BullseyeBucksForm from './components/BullseyeBucksForm';
import useLabelVatiants from '@package/hooks/src/useLabelVatiants';
import styles from './BBucksAndGiftCard.module.css';
import { BullseyeBucksProps } from './types';

const BullseyeBucks = ({ giftCards, onDelete }: BullseyeBucksProps) => {
  const { data: points, redeemLoyaltyPoints } = useBullseyeBucks();
  const { v } = useLabelVatiants();
  return (points && points.redemptionAmounts.length > 0) || (giftCards && giftCards?.length > 0) ? (
    <Accordion
      data-testid="bb-and-gift-card"
      title={v('bullseyeBucksTitle')}
      headerClassName={styles.accordionHeader}
      className={styles.cartSummaryAccordion}
      contentClassName={styles.cartSummaryAccordionContent}
      iconClassName={styles.cartSummaryAccordionIcon}
    >
      <BullseyeBucksForm
        id="bb-card-form"
        fullWidth
        buttonLabel={v('applyRewardPoints')}
        giftCards={giftCards}
        points={points}
        redeemLoyaltyPoints={redeemLoyaltyPoints}
        onDelete={onDelete}
      />
    </Accordion>
  ) : null;
};

export default BullseyeBucks;
